export default __webpack_public_path__ + "static/media/Akhlak-Hossain-Jim-Project-Invoice-Shuvro-Jaya-960.06a855b4.webp";